import { cn } from '@bliks-io/ui';

interface LogoProps {
  className?: string;
}

export function Logo({ className }: LogoProps) {
  return (
    <div className={cn('flex items-center gap-3', className)}>
      <img className="h-12.5 w-auto" src="/assets/images/logo.svg" alt="BLIKS IO Logo" />
      <div className="text-[40px] leading-12.5 font-semibold">BLIKS IO</div>
    </div>
  );
}
